import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Business } from '../models/business.model';
import { hasTag } from '../../util/tag-utils';
import { EditCommunicationComponent } from '../edit-communication/edit-communication.component';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import {AirportService} from '../../airport/airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.scss']
})
export class CommunicationComponent implements OnInit {
  @Input() business: Business;
  @Output() businessChange = new EventEmitter<Business>();
  hasTag = hasTag;
  editModeSet = false;
  ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
  isRegionalManager = false;

  constructor(private _editCommunicationsDialog: MatDialog,
              private _toggleService: EditToggleService,
              public snackBar: MatSnackBar,
              private _airportService: AirportService,
              private _businessManagerService: BusinessManagerService) { }

  async ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  openEditCommunicationsDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      business: this.business
    };

    dialogConfig.width = '500px';
    const dialogRef = this._editCommunicationsDialog.open(EditCommunicationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async (isUpdated) => {
      this.business = await this._airportService.getBusiness(this.business.id.toString());
      this.businessChange.emit(this.business);
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (!isUpdated.success) {
        this.snackBar.open(this.ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
